import React from 'react';
import { Helmet } from 'react-helmet';

import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import WhyUsSection from './WhyUsSection';

const Home = () => {
  return (
    <main className="flex flex-col">

      {/* SEO META TAGS */}
      <Helmet>
        <title>Nordic Route | Modern logistik i hela Norden</title>
        <meta
          name="description"
          content="Nordic Route erbjuder moderna logistiklösningar i hela Norden med godstransport, expressleveranser och specialtransporter. Pålitlig spårning, personlig service och effektiv ruttplanering."
        />
        <link rel="canonical" href="https://www.nordicroute.se/" />

        {/* OPEN GRAPH */}
        <meta property="og:title" content="Nordic Route | Modern logistik i hela Norden" />
        <meta
          property="og:description"
          content="Pålitliga logistiklösningar i Norden. Vi erbjuder godstransport, expressleveranser och specialtransporter med fokus på transparens och teknik."
        />
        <meta property="og:url" content="https://www.nordicroute.se/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.nordicroute.se/og-image.jpg" />

        {/* TWITTER CARD */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Nordic Route | Modern logistik i hela Norden" />
        <meta
          name="twitter:description"
          content="Logistiklösningar i Norden med fokus på spårning, precision och tydlig kommunikation."
        />
        <meta name="twitter:image" content="https://www.nordicroute.se/og-image.jpg" />

        {/* STRUCTURED DATA */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Nordic Route",
              "url": "https://www.nordicroute.se",
              "logo": "https://www.nordicroute.se/logo.png",
              "description": "Modern logistik och transportlösningar i hela Norden.",
              "sameAs": [],
              "contactPoint": [{
                "@type": "ContactPoint",
                "telephone": "+46",
                "contactType": "customer service",
                "availableLanguage": "Swedish"
              }]
            }
          `}
        </script>
      </Helmet>

      {/* PAGE SECTIONS */}
      <HeroSection />
      <ServicesSection />
      <WhyUsSection />
    </main>
  );
};

export default Home;
